// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"413":"12bde49a","946":"364e46fa"}[chunkId] + ".js";
};